<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <funds-form :fund="fund" @search="search"
                            :showLabels="false" :showSearch="true"></funds-form>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <funds-tab v-bind="{requestFunction}" ref="fundsRef" id="fundsId"/>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import fundsForm from './Form.vue'
  import fundsApi from '../../api/funds'
  import Fund from '../../models/fund'
  import fundsTab from '../components/FundsTab'

  export default {
    components: {
      fundsForm,
      fundsTab
    },

    data () {
      return {
        fund: new Fund(false, undefined),
        funds: false,
        firstAccess: true
      }
    },

    mounted () {
      window.addEventListener('keypress', e => {
        if (e.keyCode === 13) {
          this.$refs.fundsRef.refresh()
          setTimeout(() => {
            this.$scrollTo('#fundsId')
          }, 100)
        }
      })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Cerca fondi',
        createButton: {display: false}
      })
      this.$emit('addBackgroundColor', 'rgb(138,163,157)')
    },

    methods: {
      search () {
        this.firstAccess = false
        this.$refs.fundsRef.refresh()
        this.$scrollTo('#fundsId')
      },
      showFund (id) {
        this.$router.push({name: 'fundsShow', params: {id: id}})
      },
      requestFunction: function (query) {
        if (!this.firstAccess) {
          return fundsApi.search(this.fund, query)
        }
        this.firstAccess = false
        return fundsApi.search({'id': 111111}, query)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/funds/Search.vue